module.exports = __webpack_public_path__ + "d1e20984f96c02dfe534e2ce6bef14cf.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/goldencity.jpg
// module id = 770
// module chunks = 0